import config from 'cfg';
import RCore from 'RCore';
import _ from 'lodash';

export const loadOdds = (eventId, provider) => dispatch => {
    fetch(`${config.apis.ss2}/odds/match?eventId=${eventId}&provider=${provider}`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(r => r.json())
        .then(payload => {
            return dispatch({
                type: 'bulk',
                payload,
            });
        });
};

export const loadEvent = eventId => dispatch => {
    fetch(`${config.apis.ss2}/events/${eventId}`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(r => r.json())
        .then(payload => {
            return dispatch({
                type: 'eventLoaded',
                payload,
            });
        });
};

export const loadBestPlayers = (teamId, side = 'home') => dispatch => {
    fetch(`${config.apis.ss2}/incidents/goals/team/${teamId}`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(r => r.json())
        .then(r =>
            _.chain(r)
                .takeRight(20)
                .filter({ active: 1 })

                .groupBy(i => i.playerId)
                .toPairs()
                .map(pair => {
                    const incident = pair[1][0];
                    incident.count = pair[1].length;
                    return incident;
                })
                .sortBy(p => -p.count)
                .take(3)
                .value(),
        )
        .then(bestPlayers => {
            return dispatch({
                type: 'bulk',
                payload: {
                    [side]: bestPlayers,
                },
            });
        });
};

export const loadWidgets = () => dispatch => {
    return Promise.props({
        widgets: fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}`).then(
            response => response.json(),
        ),
    }).then(({ widgets }) => {
        return dispatch({
            type: 'bulk',
            payload: {
                widgets,
            },
        });
    });
};

export const initLoad = (tournamentId, seasonId) => dispatch => {
    RCore.promiseProps({
        tournament: fetch(`${config.apis.ss2}/tournaments/${tournamentId}`, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(r => r.json()),
        teams: fetch(`${config.apis.ss2}/tournaments/${tournamentId}/teams`, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(r => r.json()),
        season: fetch(
            `${config.apis.ss2}/tournaments/${tournamentId}/season?${
                seasonId === 'current' ? '' : 'seasonId=' + seasonId
            }`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            },
        )
            .then(r => r.json())
            .then(r => r.season),
    }).then(payload => {
        return dispatch({
            type: 'initLoad',
            payload,
        });
    });
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/actions.js
 **/